// useOperationBenefitGroups.js
import { useState, useCallback, useEffect } from "react";
import { operationBenefitGroupService } from "../services/operationBenefitGroupService";
import { SetAuditTrail } from "../../components/Reports/AuditTrailReportEmployeeSetup"; // ADDED

export const useOperationBenefitGroups = ({user, showGeneralMessage}) => {
  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [selectOptions, setSelectOptions] = useState([]);

  const extractErrorMessage = (err) => {
    const data = err.response?.data;
    if (!data) return "An unexpected error occurred.";

    if (typeof data === 'string') return data;

    if (data.message) return data.message;

    if (data.errors) {
      const firstErrorKey = Object.keys(data.errors)[0];
      return data.errors[firstErrorKey][0];
    }

    if (data.title) return data.title;

    return "Error performing action.";
  };

  const fetchGroups = useCallback(async () => {
    setLoading(true);
    try {
      const res = await operationBenefitGroupService.getAll();
      const data = res.data || [];
      setGroups(data);

      setSelectOptions(data.filter(g => g.isActive).map(g => ({
        value: g.id,
        label: g.description
      })));
    } catch (err) {
      showGeneralMessage(extractErrorMessage(err), false);
      console.error("Debug Error: err");
    } finally {
      setLoading(false);
    }
  }, [showGeneralMessage]);

  useEffect(() => { fetchGroups(); }, [fetchGroups]);

  // MODIFIED: Added Audit Trail
  const saveGroup = async (id, payload) => {
    setLoading(true);
    try {
      id ? await operationBenefitGroupService.update(id, payload)
        : await operationBenefitGroupService.create(payload);

      if (user) {
        await SetAuditTrail({
          User_Id: user.id,
          Action: id ? "UPDATE" : "ADD",
          Module: "Salary Module V2",
          Feature: "Benefit Group",
          Description: `${id ? 'Updated' : 'Added'} benefit group: ${payload.description}`
        });
      }

      if (showGeneralMessage) showGeneralMessage("Category saved successfully", true);
      fetchGroups();
      return { success: true };
    } catch (err) {
      showGeneralMessage(extractErrorMessage(err), false);
      console.error("Debug Error: err");
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return { groups, selectOptions, loading, saveGroup, refresh: fetchGroups };
};